import './flickty-dots.scss';

import * as React from 'react';

interface Props {
  dots: Array<string>;
  centerElementIndex: number;
  onDotClick: (value: number) => void;
}

const FlackityDots = (props: Props) => {
  const {dots, centerElementIndex, onDotClick} = props;
  return (
    <div className="flickty-dots">
      {dots.map((it, index) => {
        return (
          <p className="flickty-dots__item" key={index}>
            <input type="radio" className="flickty-dots__radio" name="slider-item" id={`input-${index}`}
              checked={index === centerElementIndex}
              onChange={() => onDotClick(index)}
            />
            <label htmlFor={`input-${index}`} className="flickty-dots__label"><span className="visually-hidden">Pin for slide</span></label>
          </p>
        );
      })}
    </div>
  );
};

export default FlackityDots;
